import { RateOutput } from "@/common/types/trpc";

export const getVisibleAddOnRates = (rates: RateOutput[]): RateOutput[] =>
  rates.filter((rate) => rate.isAddOn && !rate.isHidden).sort((a, b) => (a.sortIndex ?? 0) - (b.sortIndex ?? 0));
